/* Announcement overlay — stream broadcast countdown */

/* Full-player overlay, sits above poster/video */
.overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  overflow: hidden;
}

/* Blurred background — same logo, stretched and blurred */
.blurred {
  position: absolute;
  inset: 0;
  z-index: 1;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  filter: blur(24px);
  opacity: 0.8;
}

/* Content column — centred above the blur */
.inner {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 24px;
  overflow: auto;
}

/* Broadcast image wrapper */
.imageWrapper {
  position: relative;
  width: 594px;
  max-width: 100%;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Info block below the image */
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 640px;
  width: 100%;
  gap: 16px;
}

/* Date / countdown row */
.dateRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
  flex-wrap: wrap;
}

.dateText {
  color: #fff;
}

.dateSep {
  color: #bababa;
  opacity: 0.5;
}

.countdownText {
  color: #fff;
}

/* Broadcast title */
.title {
  margin: 0;
  width: 100%;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #fff;
}

/* Streamer row */
.streamerRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* Avatar + name group */
.streamerInfo {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 2px;
  object-fit: cover;
  flex-shrink: 0;
}

.streamerName {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  color: #b8d5ff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* "анонсировал стрим" label */
.announced {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  color: #fff;
  white-space: nowrap;
}

/* Game pill */
.gamePill {
  background: rgba(68, 83, 126, 0.5);
  border-radius: 360px;
  padding: 4px 16px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  color: #fff;
  white-space: nowrap;
}

/* ─────────────────────────────────────────────────────────
   Layout 2 — portrait image (side-by-side: image left, info right)
   Used when broadcast_logo naturalHeight > naturalWidth
   ───────────────────────────────────────────────────────── */

/* Row-direction inner container — image fills full height, info fills remaining width */
.innerRow {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  overflow: hidden;
}

/* Portrait image wrapper — takes full container height, width derived from aspect ratio */
.imageWrapperPortrait {
  position: relative;
  height: 100%;
  max-height: 80%;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

/* Info column — grows to fill remaining space, left-aligned content */
.infoPortrait {
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  max-width: 640px;
  gap: 16px;
}

/* Date / countdown row — left-aligned (no justify-center) */
.dateRowPortrait {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
  flex-wrap: wrap;
  width: 100%;
}

/* Broadcast title — left-aligned */
.titlePortrait {
  margin: 0;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #fff;
}

/* Streamer row — left-aligned */
.streamerRowLeft {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}
